import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import { ViewVariant } from "@/common/ts/layout";
import { VehicleDto } from "@/core/api/generated/v1";

import EntityInboxList from "../../../Chat/ListView/EntityInboxList";

interface Props {
  vehicle: VehicleDto;
}

export default function InboxTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={1} sx={{ p: 0, borderRadius: "inherit" }}>
        <AuthorizedTenantElement
          tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]}
          withAlert
        >
          <EntityInboxList
            displayProps={{
              header: false,
              viewVariant: ViewVariant.Tab,
            }}
            defaultValues={{
              vehicleId: vehicle.id!,
            }}
          />
        </AuthorizedTenantElement>
      </ViewContentBlock>
    </PageTabContent>
  );
}
